import {DDR} from './ddr.class';

export class DDRMen1418Strategy extends DDR {
  constructor() {
    super([900, 5, 15, 75, 75, 1.2, 1.3, 16, 1.3, 400, 2.4, 5, 25, 550, 1300, 35, 890, 3, 150, 11, 410, 2.2, 1250, 55, 11]);
  }
}
